import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import FundCodeForm from "components/FundCode/form"
import {
  getByIdFundCode,
  updateFundCode,
} from "store/fund-code/fund-code-action"
import { fundCodeAction } from "store/fund-code/fund-code-slice"

const EditFundCode = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, error, fundCode } = useSelector(state => state.fundCode)

  useEffect(() => {
    dispatch(getByIdFundCode(id))

    return () => {
      dispatch(fundCodeAction.resetState())
    }
  }, [dispatch, id])

  return (
    <FundCodeForm
      fundCode={fundCode}
      onSubmit={values => dispatch(updateFundCode(id, values, navigate))}
      loading={loading}
      error={error}
      formMode={"Edit"}
    />
  )
}

export default EditFundCode
